import { z } from 'zod'

export const rucValidator = z.string().length(11, 'RUC debe tener 11 digitos')

export const emailValidator = z.string().email('Email invalido').optional().or(z.literal(''))

export const requiredString = (msg = 'Campo requerido') => z.string().min(1, msg)

const toNumber = z.union([z.number(), z.string()])
  .transform((val) => (val === '' || val === undefined ? 0 : Number(val)))

export const requiredNumber = (msg = 'Campo requerido') =>
  toNumber.pipe(z.number({ message: msg }).min(1, msg))

export const optionalDate = z.string().optional().or(z.literal(''))

export const requiredDate = (msg = 'Fecha es requerida') => z.string().min(1, msg)

export const optionalNumber = toNumber.pipe(z.number()).optional()

export const maxLength = (max: number, msg?: string) => z.string().max(max, msg ?? `Máximo ${max} caracteres`)

/** Validates that an emission/presentation date is not in the future */
export function validateEmissionDate(
  date: string | undefined,
  path: string,
  ctx: z.RefinementCtx,
) {
  if (!date) return
  const today = new Date().toISOString().split('T')[0]
  if (date > today) {
    ctx.addIssue({ code: z.ZodIssueCode.custom, path: [path], message: 'La fecha de emision no puede ser futura' })
  }
}

/** Validates that expiration date is after emission date */
export function validateExpirationAfterEmission(
  emissionDate: string | undefined,
  expirationDate: string | undefined,
  expirationPath: string,
  ctx: z.RefinementCtx,
) {
  if (!emissionDate || !expirationDate) return
  if (expirationDate <= emissionDate) {
    ctx.addIssue({ code: z.ZodIssueCode.custom, path: [expirationPath], message: 'La fecha de caducidad debe ser posterior a la de emision' })
  }
}
